<!--&================== TITLE LIBRARY ==================&-->
<div class="title-components">
  <h1>Grupos</h1>
</div>

<div class="Options-Menu">
  <!---================= CONTAINER SELECT TYPE Finance =================--->
  <div *ngIf="isList" class="Card-Option container-global-components">
    <div class="Icon-Left">
      <button (click)="Search_Validate()" class="Local-Icon-Card button-square">
        <i class="fa-solid fa-magnifying-glass"></i>
      </button>
    </div>

    <div class="Container-Card Search-file">
      <div class="Input-Option Search-file">
        <div class="search inputText">
          <input
            type="text"
            placeholder="Buscar Grupo (Mínimo 2 caracteres)"
            [(ngModel)]="Input_Search"
            (keyup)="Search_Group()"
            (keyup)="Search_Enter($event)"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-book-bookmark"></i>
      </div>
    </div>

    <div class="Container-Card Search-file">
      <div class="Input-Option Container-Select-Type">
        <div class="Container-input Inputng-Select">
          <i class="fa-solid fa-book-bookmark"></i>
          <ng-select
            [searchable]="false"
            [clearable]="false"
            bindLabel="Name"
            bindValue="Slug"
            [items]="LibraryFilterOptions"
            [(ngModel)]="SelectedLibraryFilter"
            (change)="OnChange_Library_Filter()"
            placeholder="Filtrar por librería"
          ></ng-select>
          <i class="fa-solid fa-angle-down"></i>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isList" class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-gear"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Actualizar información</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <!---================= CONTAINER RELOAD PAGE =================--->
        <div class="Container-Buttons">
          <div (click)="Reload_Page()" class="Btn-Option button-square">
            <span class="Tool-Tip">Recargar pagina</span>
            <i class="fa-solid fa-rotate-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!---================= CONTAINER RELOAD PAGE =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-users"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Opciones De Grupo</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons">
          <button
            (click)="Toggle_Modal_Create_Group(true)"
            class="Btn-Option Add button-square"
          >
            <span class="Tool-Tip">Agregar nuevo grupo al sistema</span>
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-hashtag"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Total De Grupos</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <!---================= CONTAINER GENERATE REPORT =================--->
        <div class="Container-Buttons">
          <div class="Generate-Report-Level">
            {{ All_Groups.length }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-list"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Registros en forma de {{ this.isList ? "carta" : "lista" }}</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons Switch">
          <div class="Input-Switch">
            <input
              [(ngModel)]="isList"
              type="checkbox"
              name=""
              id="Inheritance_Check"
            />
            <label for="Inheritance_Check"></label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="All_Groups_Copy.length > 0 && LoadPage && isList" class="Card">
  <div class="Card__Container">
    <div
      *ngFor="let Group of All_Groups_Copy; let i = index"
      class="Card__Container--item"
    >
      <div class="Card__Container--item--Body">
        <div
          class="Card__Container--item--Body--Header"
          (click)="Toggle_Modal_Option(i)"
        >
          <i class="fa-solid fa-ellipsis-vertical"></i>

          <div
            class="Card__Container--item--Body--Header--Options"
            id="Card_Option{{ i }}"
          >
            <button
              [routerLink]="['/Dashboard/Admin/RelationG/', Group.ID_G]"
              class="Card__Container--item--Body--Header--Options--Option button-square"
            >
              <i class="fa-regular fa-user"></i>
            </button>

            <button
              (click)="Open_Update_Group(Group)"
              class="Card__Container--item--Body--Header--Options--Option button-square Edit"
            >
              <i class="fa-solid fa-pencil"></i>
            </button>

            <button
              (click)="Delete_Group(Group)"
              class="Card__Container--item--Body--Header--Options--Option button-square Remove"
            >
              <i class="fa-regular fa-trash-can"></i>
            </button>
          </div>
        </div>

        <div class="Card__Container--item--Body--Container">
          <div class="Card__Container--item--Body--Container--Square">
            <span>{{ Format_Initials(Group.Nombre) }}</span>
          </div>

          <div class="Card__Container--item--Body--Container--Info">
            <div class="Card__Container--item--Body--Container--Info--Title">
              {{ Group.Nombre }}
            </div>

            <div class="Card__Container--item--Body--Container--Info--Library">
              {{ Get_Library_Badge(Group.Library_Slug) }}
            </div>

            <div
              class="Card__Container--item--Body--Container--Info--Description"
            >
              {{ Format_Description(Group.Descripcion) }}
            </div>

            <div
              class="Card__Container--item--Body--Container--Info--Permisions"
            >
              <ng-container *ngFor="let Group_Perm of Group.Permission">
                <ng-container *ngFor="let Permission of Permisions">
                  <div
                    *ngIf="
                      Group_Perm.toUpperCase() ===
                      Permission.Permission.toUpperCase()
                    "
                    class="Card__Container--item--Body--Container--Info--Permisions--Icon"
                  >
                    <span
                      class="Card__Container--item--Body--Container--Info--Permisions--Icon--Tool-Tip"
                    >
                      {{ Permission.Value }}
                    </span>
                    <i class="fa-solid {{ Permission.Icon }}"></i>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-paginator
    (onPageChange)="onPageChange($event)"
    [first]="first"
    [rows]="rows"
    [totalRecords]="
      Input_Search.length < 2
        ? All_Groups.length
        : All_Groups_Copy_Search.length
    "
    [rowsPerPageOptions]="[5, 10, 15, 20, 30]"
  ></p-paginator>
</div>

<!--&================== CONTAINER GENERAL LIBRARY ==================&-->
<div
  *ngIf="All_Groups_Copy.length > 0 && LoadPage && !isList"
  class="container-global-components ConFLFIN"
>
  <div class="Table-Lib Table-container-Global">
    <p-table
      #dt
      [value]="All_Groups"
      [(selection)]="All_Groups_Copy_Table"
      dataKey="id"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 15, 25, 50]"
      [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      [filterDelay]="0"
      [globalFilterFields]="['Nombre', 'Descripcion', 'Library_Slug']"
    >
      <!--&================= SEARCH AND ALL Groups =================&-->
      <ng-template pTemplate="caption">
        <div class="SectionCreateTotal Section-Groups Table_NG">
          <div class="left-CT">
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i
              ><input
                [(ngModel)]="Input_Search_Table"
                type="text"
                (input)="$any(dt).filterGlobal(Input_Search_Table, 'contains')"
                placeholder="Buscar grupo"
              />
            </div>
          </div>
          <div class="right-CT">
            <div class="AllFiles">
              Total de Grupos: <b>{{ All_Groups.length }}</b>
              <i class="fa-solid fa-users"></i>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <ng-container *ngFor="let Header of Headers_Groups">
            <ng-container *ngIf="Header.Key_Header === 'NAM'">
              <th pSortableColumn="Nombre" class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Nombre"></p-sortIcon>
                    <p-columnFilter
                      type="text"
                      field="Nombre"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DES'">
              <th pSortableColumn="Descripcion" class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Descripcion"></p-sortIcon>
                    <p-columnFilter
                      type="text"
                      field="Descripcion"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'LIB'">
              <th pSortableColumn="Library_Slug" class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Library_Slug"></p-sortIcon>
                    <p-columnFilter
                      type="text"
                      field="Library_Slug"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'PER'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th"> </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'OPTIO'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                </div>
              </th>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-Group>
        <tr>
          <td
            *ngFor="let Header of Headers_Groups"
            class="{{ Header.Key_Header }}"
          >
            <ng-container *ngIf="Header.Key_Header === 'NAM'">
              {{ Group.Nombre }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'LIB'">
              {{ Get_Library_Badge(Group.Library_Slug) }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DES'">
              {{ Format_Description(Group.Descripcion) }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'PER'">
              <div class="Container-Buttons--Permission">
                <ng-container *ngFor="let Group_Perm of Group.Permission">
                  <ng-container *ngFor="let Permission of Permisions">
                    <div
                      *ngIf="Group_Perm === Permission.Permission"
                      class="Container-Buttons--Permission--Icon"
                    >
                      <span
                        class="Container-Buttons--Permission--Icon--Tool-Tip"
                      >
                        {{ Permission.Value }}
                      </span>
                      <i class="fa-solid {{ Permission.Icon }}"></i>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'OPTIO'">
              <button
                [routerLink]="['/Dashboard/Admin/RelationG/', Group.ID_G]"
                class="Btn-Option button-square"
              >
                <i class="fa-regular fa-user"></i>
              </button>

              <button
                (click)="Open_Update_Group(Group)"
                class="Btn-Option button-square Edit"
              >
                <i class="fa-solid fa-pencil"></i>
              </button>
              <button
                (click)="Delete_Group(Group)"
                class="Btn-Option button-square Remove"
              >
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="All_Groups.length > 0" colspan="8">Sin coincidencias.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div
  *ngIf="All_Groups_Copy.length === 0 && LoadPage && Input_Search.length > 0"
  class="container-global-components ConFLFIN"
>
  <div class="Not-Group">
    <div class="Img-Not">
      <img src="./assets/Global/Ilustrations/No-Find.png" alt="" />
    </div>
    <div class="Text-Not-Group">
      No existe ningún grupo con el nombre {{ Input_Search }}
    </div>
  </div>
</div>

<div
  *ngIf="All_Groups_Copy.length === 0 && LoadPage && Input_Search.length === 0"
  class="container-global-components ConFLFIN"
>
  <div class="Not-Group">
    <div class="Img-Not">
      <img src="./assets/Global/Ilustrations/Not-Group.png" alt="" />
    </div>
    <div class="Text-Not-Group">¡Aún no existen grupos en el sistema!</div>
  </div>
</div>

<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR CREATE GROUP =====================--->
<section class="Modal-Global" id="Modal_Create_Group">
  <div class="wrapper">
    <div class="Pro-popup-CG popup">
      <div class="Pro-inside-CG popup-inside">
        <div class="Pro-backgrounds-CG backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form [formGroup]="Form_Group_Create" (ngSubmit)="Save_Group()">
        <div class="Pro-content-CG content">
          <button
            (click)="Toggle_Modal_Create_Group(false)"
            type="button"
            id="Btn-Close-Add-Top"
            class="Btn-Close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <div class="Content-Top">
            <h2>Crear Grupo</h2>
          </div>

          <div class="Content-body">
            <div class="Content-grid-2">
              <div class="Text-icon">Nombre</div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-signature"></i
                ><input
                  id="Idinput_Name_Group"
                  type="text"
                  formControlName="Name"
                  placeholder="Nombre de grupo…"
                />
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">Descripción</div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-signature"></i
                ><input
                  id="Idinput_Desc_Group"
                  type="text"
                  formControlName="Description"
                  placeholder="Descripción del grupo…"
                />
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">Librería</div>
              <div class="Container-input Inputng-Select">
                <i class="fa-solid fa-book-bookmark"></i>
                <ng-select
                  [searchable]="false"
                  [clearable]="false"
                  bindLabel="Name"
                  bindValue="Slug"
                  [items]="LibraryFormOptions"
                  formControlName="LibrarySlug"
                  placeholder="Seleccionar librería"
                ></ng-select>
                <i class="fa-solid fa-angle-down"></i>
              </div>
            </div>

            <div class="Content-grid-1">
              <div class="Text-icon">Permisos</div>
            </div>

            <div class="Content-grid-3">
              <ng-container *ngFor="let Permission of Permisions">
                <div
                  *ngIf="Permission.Permission !== P_CDMS.Reports && Permission.Permission !== P_CDMS.Administrador"
                  class="Container-Permission"
                >
                  <div class="Container-Input-Check Input-CheckBox">
                    <input
                      type="checkbox"
                      class="ui-checkbox"
                      [formControlName]="Permission.Permission"
                    />
                  </div>
                  <div class="Permission">
                    <div class="icon">
                      <i class="fa-solid {{ Permission.Icon }}"></i>
                    </div>
                    <div class="text">
                      {{ Permission.Value }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form3 btn-icon-text">
              <i class="fa-solid fa-check-double"></i
              ><span class="text">Crear grupo</span>
            </button>
            <button
              (click)="Toggle_Modal_Create_Group(false)"
              type="button"
              class="Btn-LCancel-Form Btn-Close-Modal"
            >
              <span>Cerrar</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL FOR UPDATE GROUP =====================--->
<section class="Modal-Global" id="Modal_Update_Group">
  <div class="wrapper">
    <div class="Pro-popup-CG popup">
      <div class="Pro-inside-CG popup-inside">
        <div class="Pro-backgrounds-CG backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form [formGroup]="Form_Group_Update" (ngSubmit)="Save_Group_Update()">
        <div class="Pro-content-CG content">
          <button
            (click)="Toggle_Modal_Update_Group(false)"
            type="button"
            id="Btn-Close-Add-Top"
            class="Btn-Close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
          <div class="Content-Top">
            <h2>Editar Grupo</h2>
          </div>

          <div class="Content-body">
            <div class="Content-grid-2">
              <div class="Text-icon">Nombre</div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-signature"></i
                ><input
                  id="Idinput_Name_Group_Update"
                  type="text"
                  formControlName="Name"
                  placeholder="Nombre de grupo…"
                />
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">Descripción</div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-signature"></i
                ><input
                  id="Idinput_Desc_Group_Update"
                  type="text"
                  formControlName="Description"
                  placeholder="Descripción del grupo…"
                />
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">Librería</div>
              <div class="Container-input Inputng-Select">
                <i class="fa-solid fa-book-bookmark"></i>
                <ng-select
                  [searchable]="false"
                  [clearable]="false"
                  bindLabel="Name"
                  bindValue="Slug"
                  [items]="LibraryFormOptions"
                  formControlName="LibrarySlug"
                  placeholder="Seleccionar librería"
                ></ng-select>
                <i class="fa-solid fa-angle-down"></i>
              </div>
            </div>

            <div class="Content-grid-1">
              <div class="Text-icon">Permisos</div>
            </div>

            <div class="Content-grid-3">
              <ng-container *ngFor="let Permission of Permisions">
                <div
                  *ngIf="Permission.Permission !== P_CDMS.Reports && Permission.Permission !== P_CDMS.Administrador"
                  class="Container-Permission"
                >
                  <div class="Container-Input-Check Input-CheckBox">
                    <input
                      type="checkbox"
                      class="ui-checkbox"
                      [formControlName]="Permission.Permission"
                    />
                  </div>
                  <div class="Permission">
                    <div class="icon">
                      <i class="fa-solid {{ Permission.Icon }}"></i>
                    </div>
                    <div class="text">
                      {{ Permission.Value }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form3 btn-icon-text">
              <i class="fa-solid fa-check-double"></i
              ><span class="text">Guardar cambios</span>
            </button>
            <button
              (click)="Toggle_Modal_Update_Group(false)"
              type="button"
              class="Btn-LCancel-Form Btn-Close-Modal"
            >
              <span>Cerrar</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
